import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Outlet, Navigate, useLocation } from 'react-router-dom'
import { setHostAnalyticsUser } from '../../utils/hostAnalytics'
import { buildNextPath } from '../../utils/authRedirect'

const PrivateRoutes = () => {
    const location = useLocation()
    const { hostInfo } = useSelector((state) => state.host)
    const next = buildNextPath(location)

    useEffect(() => {
        if (hostInfo?._id) setHostAnalyticsUser(hostInfo._id)
    }, [hostInfo?._id])

    return (
        hostInfo ? <Outlet /> : <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />
    )
}

export default PrivateRoutes
